"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _ethers = require("ethers");

var _web = _interopRequireDefault(require("web3"));

var _ONRegistrarController = require("./contract/ONRegistrarController.json");

var _ONRegistryManager = require("./contract/ONRegistryManager.json");

var _ONRegistryEndPoint = require("./contract/ONRegistryEndPoint.json");

var _DefaultResolver = require("./contract/DefaultResolver.json");

var _ONRegistryCore = require("./contract/ONRegistryCore.json");

var _LayerZeroManager = require("./contract/LayerZeroManager.json");

var _Erc20BalanceOf = require("./contract/Erc20BalanceOf.json");

var _ChainLink = require("./contract/ChainLink.json");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _records = require("./utils/records");

var _util = require("./utils/util");

var _moment = _interopRequireDefault(require("moment"));

var _PremiumPriceOracle = _interopRequireDefault(require("./utils/PremiumPriceOracle"));

var _sdkCore = require("@uniswap/sdk-core");

var _quote3 = require("./libs/quote");

var sdkConfig = require('./config/config');

var Provider = _ethers.ethers.providers.Provider;
var Chain = /*#__PURE__*/(0, _createClass2["default"])(function Chain(options) {
  (0, _classCallCheck2["default"])(this, Chain);
  var chainId = options.chainId,
      rpcProvider = options.rpcProvider,
      rpcProviders = options.rpcProviders,
      registarAddr = options.registarAddr,
      managerAddr = options.managerAddr,
      registryEndPointAddr = options.registryEndPointAddr,
      registryCoreAddr = options.registryCoreAddr,
      defaultResolverAddr = options.defaultResolverAddr,
      layerZeroManagerAddr = options.layerZeroManagerAddr,
      chainlinkAddr = options.chainlinkAddr;
  this.rpcProvider = rpcProvider;
  this.rpcProviders = rpcProviders;
  this.chainId = chainId;
  this.registarAddr = registarAddr;
  this.managerAddr = managerAddr;
  this.registryEndPointAddr = registryEndPointAddr;
  this.registryCoreAddr = registryCoreAddr;
  this.defaultResolverAddr = defaultResolverAddr;
  this.layerZeroManagerAddr = layerZeroManagerAddr;
  this.chainlinkAddr = chainlinkAddr;
});

function setAddrWithResolver(_x) {
  return _setAddrWithResolver.apply(this, arguments);
}

function _setAddrWithResolver() {
  _setAddrWithResolver = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28(_ref) {
    var name, coinType, address, resolverAddr, signer, tokenId, resolverContract;
    return _regenerator["default"].wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            name = _ref.name, coinType = _ref.coinType, address = _ref.address, resolverAddr = _ref.resolverAddr, signer = _ref.signer;
            tokenId = nameHash(name);
            resolverContract = getResolverContract({
              address: resolverAddr,
              provider: signer
            });
            return _context28.abrupt("return", resolverContract.functions["setAddr(uint256,uint256,bytes)"](tokenId, coinType, _ethers.ethers.utils.toUtf8Bytes(address)));

          case 4:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _setAddrWithResolver.apply(this, arguments);
}

var ON = /*#__PURE__*/function () {
  function ON(options) {
    (0, _classCallCheck2["default"])(this, ON);
    var env = options.env,
        providerOrSigner = options.providerOrSigner,
        rpcUrls = options.rpcUrls;
    var contractAddrs = sdkConfig.contractAddrs[env];

    if (!contractAddrs) {
      throw Error(env + " is Not Supported");
    }

    var network = sdkConfig.envNetworks[env];

    if (!network) {
      throw Error("Not supported env: " + env);
    }

    if (Provider.isProvider(providerOrSigner)) {
      // detect ethersProvider
      this.provider = providerOrSigner;
      this.signer = this.provider.getSigner();
    } else if (_ethers.ethers.Wallet.isSigner(providerOrSigner)) {
      this.provider = providerOrSigner.provider;
      this.signer = providerOrSigner;
    } else if (providerOrSigner) {
      // wrap as Web3Provider
      this.provider = new _ethers.ethers.providers.Web3Provider(providerOrSigner);
      this.signer = this.provider.getSigner();
    }

    this.supportChainIds = [];
    this.chainMap = {};
    var defaultRpcUrls = sdkConfig.rpcUrls[network];

    for (var chainId in contractAddrs) {
      var urls = '';

      if (defaultRpcUrls[chainId]) {
        urls = defaultRpcUrls[chainId]['rpcUrl'];
      }

      if (rpcUrls && rpcUrls[chainId] && rpcUrls[chainId] != "") {
        urls = rpcUrls[chainId];
      }

      if (!urls || urls == "") {
        throw Error("No rpcUrl provided for chainId: " + chainId);
      }

      var urlArr = urls.split(",");

      if (urlArr == null || urlArr.length == 0) {
        throw Error("No rpcUrls provided for chainId: " + chainId);
      }

      var networkId = parseInt(chainId);
      var rpcProvider = new _ethers.ethers.providers.JsonRpcProvider(urlArr[0], networkId);
      var rpcProviders = [];

      for (var i = 0; i < urlArr.length; i++) {
        rpcProviders.push(new _ethers.ethers.providers.JsonRpcProvider(urlArr[i], networkId));
      }

      var registarAddr = contractAddrs[chainId]['registarAddr'];
      var managerAddr = contractAddrs[chainId]['managerAddr'];
      var registryEndPointAddr = contractAddrs[chainId]['registryEndPointAddr'];
      var registryCoreAddr = contractAddrs[chainId]['registryCoreAddr'];
      var defaultResolverAddr = contractAddrs[chainId]['defaultResolverAddr'];
      var layerZeroManagerAddr = contractAddrs[chainId]['layerZeroManagerAddr'];
      var chainlinkAddr = contractAddrs[chainId]['chainlinkAddr'];
      this.chainMap[chainId] = new Chain({
        rpcProvider: rpcProvider,
        rpcProviders: rpcProviders,
        chainId: parseInt(chainId),
        registarAddr: registarAddr,
        managerAddr: managerAddr,
        registryEndPointAddr: registryEndPointAddr,
        registryCoreAddr: registryCoreAddr,
        defaultResolverAddr: defaultResolverAddr,
        layerZeroManagerAddr: layerZeroManagerAddr,
        chainlinkAddr: chainlinkAddr
      });
      this.supportChainIds.push(parseInt(chainId));
    }
  }

  (0, _createClass2["default"])(ON, [{
    key: "name",
    value: function name(_name) {
      return new Name({
        root: this,
        name: _name,
        provider: this.provider,
        signer: this.signer,
        supportChainIds: this.supportChainIds,
        chainMap: this.chainMap
      });
    }
    /**
     *  quoteToken for one dollar
     * @param {inToken} inToken  only USDT/USDC/WETH/ETH
     * @param {outToken} outToken 
     * @returns 
     */

  }, {
    key: "quoteToken",
    value: function () {
      var _quoteToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(inToken, outToken) {
        var chainId, chain, rpcProvider, value, inUsdt, outEth, rpcProviders, usdtToEth, unitBn, usdtToEthWeiBn;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                chainId = outToken.chainId;
                chain = this.chainMap[chainId];

                if (chain) {
                  _context.next = 4;
                  break;
                }

                throw Error("Unsupport chainId: " + chainId);

              case 4:
                rpcProvider = chain.rpcProvider;
                _context.next = 7;
                return (0, _quote3.quoteForOneDollar)(rpcProvider, inToken, outToken, 1);

              case 7:
                value = _context.sent;

                if (!(inToken['symbol'] == 'WETH' || inToken['symbol'] == 'ETH')) {
                  _context.next = 21;
                  break;
                }

                inUsdt = new _sdkCore.Token(1, '0xdac17f958d2ee523a2206206994597c13d831ec7', 6, 'USDT', 'USDT');
                outEth = new _sdkCore.Token(1, '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', 18, 'ETH', 'ETH');
                outEth['feeAmount'] = 100; // 0.01% * 1000000

                rpcProviders = this.chainMap[1].rpcProviders;
                _context.next = 15;
                return (0, _quote3.quote)(rpcProviders, inUsdt, outEth, 1000000);

              case 15:
                usdtToEth = _context.sent;
                console.log("value: ", value);
                console.log("usdtToEth: ", usdtToEth);
                unitBn = new _bignumber["default"]("1000000000000000000");
                usdtToEthWeiBn = new _bignumber["default"](usdtToEth).dividedBy(unitBn); // the value equals $1

                value = usdtToEthWeiBn.multipliedBy(new _bignumber["default"](value)).toFixed(0);

              case 21:
                return _context.abrupt("return", value);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function quoteToken(_x2, _x3) {
        return _quoteToken.apply(this, arguments);
      }

      return quoteToken;
    }()
    /**
     * quote for two tokens
     * @param {inToken} inToken  only USDT/USDC/WETH/ETH
     * @param {outToken} outToken 
     * @param {amount} amount
     * @returns 
     */

  }, {
    key: "quote",
    value: function () {
      var _quote2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(inToken, outToken, amount) {
        var chainId, chain, rpcProviders;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                chainId = outToken.chainId;
                chain = this.chainMap[chainId];

                if (chain) {
                  _context2.next = 4;
                  break;
                }

                throw Error("Unsupport chainId: " + chainId);

              case 4:
                rpcProviders = chain.rpcProviders;
                _context2.next = 7;
                return (0, _quote3.quote)(rpcProviders, inToken, outToken, amount);

              case 7:
                return _context2.abrupt("return", _context2.sent);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function quote(_x4, _x5, _x6) {
        return _quote2.apply(this, arguments);
      }

      return quote;
    }()
  }, {
    key: "currency",
    value: function currency(contract, chainId, precisionNum) {
      return new Currency({
        contract: contract,
        chainId: chainId,
        provider: this.provider,
        signer: this.signer,
        precisionNum: precisionNum,
        chainMap: this.chainMap
      });
    }
  }, {
    key: "getUsdToWei",
    value: function () {
      var _getUsdToWei = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(chainId) {
        var inToken, outToken, _result, chain, rpcProviders, promisAny, i, rpcProvider, chainlinkAddr, chainlinkContract, result, resultBn, tmp, ret;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (chainId == 280) {
                  // zk testnet (admin-back needs too)
                  chainId = 11155111;
                } else if (chainId == 324) {
                  // zk mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 59140) {
                  // linea testnet (admin-back needs too)
                  chainId = 11155111;
                } else if (chainId == 59144) {
                  // linea mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 1442) {
                  // op zkevm testnet (admin-back needs too)
                  chainId = 11155111;
                } else if (chainId == 1101) {
                  // op zkevm mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet
                } else if (chainId == 5611) {
                  // op-bnb testnet (admin-back needs too)
                  chainId = 97; // same as bsc testnet  (admin-back needs too)
                } else if (chainId == 204) {
                  // op-bnb mainnet (admin-back needs too)
                  chainId = 56; // same as bsc mainnet (admin-back needs too)
                } else if (chainId == 534352) {
                  // scroll mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 169) {
                  // manta mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 3441005 || chainId == 3441006) {
                  chainId = 11155111; // same as eth testnet (admin-back needs too)
                } else if (chainId == 168587773) {
                  // blast testnet
                  chainId = 11155111; // same as eth testnet (admin-back needs too)
                } else if (chainId == 81457) {
                  // blast mainnet
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 1687) {
                  // mint testnet
                  chainId = 11155111; // same as eth testnet (admin-back needs too)
                } else if (chainId == 919) {
                  // mode testnet (admin-back needs too)
                  chainId = 11155111;
                } else if (chainId == 34443) {
                  // mode mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                } else if (chainId == 7777777) {
                  // zora mainnet (admin-back needs too)
                  chainId = 1; // same as eth mainnet (admin-back needs too)
                }

                if (!(chainId == 71 || chainId == 1030)) {
                  _context3.next = 3;
                  break;
                }

                throw Error("Unsupport chainId: " + chainId);

              case 3:
                if (!(chainId == 7001)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", new _bignumber["default"]("660729349612859943"));

              case 5:
                if (!(chainId == 7000)) {
                  _context3.next = 13;
                  break;
                }

                inToken = new _sdkCore.Token(1, '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', 18, 'ETH', 'ETH');
                outToken = new _sdkCore.Token(1, '0xf091867ec603a6628ed83d274e835539d82e9cc8', 18, 'ZETA', 'ZETA');
                outToken['feeAmount'] = 3000;
                _context3.next = 11;
                return this.quoteToken(inToken, outToken);

              case 11:
                _result = _context3.sent;
                return _context3.abrupt("return", new _bignumber["default"](_result));

              case 13:
                chain = this.chainMap[chainId];

                if (chain) {
                  _context3.next = 16;
                  break;
                }

                throw Error("Unsupport chainId: " + chainId);

              case 16:
                rpcProviders = chain.rpcProviders;

                if (!(!rpcProviders || rpcProviders.length == 0)) {
                  _context3.next = 19;
                  break;
                }

                throw Error("Unsupport chainId: " + chainId);

              case 19:
                promisAny = [];

                for (i = 0; i < rpcProviders.length; i++) {
                  rpcProvider = rpcProviders[i];
                  chainlinkAddr = this.chainMap[chainId].chainlinkAddr; // Create a new Contract object for the Chainlink Price Feed contract

                  chainlinkContract = new _ethers.ethers.Contract(chainlinkAddr, _ChainLink.abi, rpcProvider); // Call the latestAnswer function on the Chainlink contract using the dynamically generated function signature

                  promisAny.push(chainlinkContract.latestAnswer());
                }

                _context3.next = 23;
                return Promise.any(promisAny);

              case 23:
                result = _context3.sent;

                if (!(result == 0)) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", result);

              case 26:
                // let result = await chainlinkContract.latestAnswer();
                // if (result == 0) {
                //   return result
                // }
                resultBn = new _bignumber["default"](result.toString()); // transfer to wei value

                tmp = new _bignumber["default"]("1000000000000000000").multipliedBy(new _bignumber["default"]("100000000"));
                ret = tmp.div(resultBn);
                return _context3.abrupt("return", new _bignumber["default"](ret.toFixed(0)));

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getUsdToWei(_x7) {
        return _getUsdToWei.apply(this, arguments);
      }

      return getUsdToWei;
    }()
    /**
     * register a domain
     * @param {signature} signature
     * @param {contents} contents
     * @param {commissions} commissions
     * @param {pay value} value
     */

  }, {
    key: "register",
    value: function () {
      var _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(signature, contents, commissions, value) {
        var gasLimitRatio, network, chainId, registarAddr, registarControllerContract, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.provider) {
                  _context4.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                gasLimitRatio = 1.05;
                _context4.next = 5;
                return this.provider.getNetwork();

              case 5:
                network = _context4.sent;
                chainId = network.chainId;
                registarAddr = this.chainMap[chainId].registarAddr;
                registarControllerContract = getRegistarControllerContract({
                  address: registarAddr,
                  provider: this.signer
                });

                if (!(!signature || signature == "")) {
                  _context4.next = 11;
                  break;
                }

                throw Error("No signature provided");

              case 11:
                if (!(!contents || contents == "")) {
                  _context4.next = 13;
                  break;
                }

                throw Error("No contents provided");

              case 13:
                if (!(!value || value == "")) {
                  _context4.next = 15;
                  break;
                }

                throw Error("No value provided");

              case 15:
                _context4.next = 17;
                return registarControllerContract.estimateGas.register(signature, contents, commissions, {
                  value: value
                });

              case 17:
                estimateGas = _context4.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  value: value,
                  gasLimit: gasLimit.toFixed(0)
                };
                _context4.next = 22;
                return registarControllerContract.register(signature, contents, commissions, options);

              case 22:
                return _context4.abrupt("return", _context4.sent);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function register(_x8, _x9, _x10, _x11) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
    /**
     * register a domain with erc20 token
     * @param {signature} signature
     * @param {contents} contents
     * @param {commissions} commissions
     * @param {pay value} value
     */

  }, {
    key: "registerWithToken",
    value: function () {
      var _registerWithToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(signature, contents, commissions, value) {
        var gasLimitRatio, network, chainId, registarAddr, registarControllerContract, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.provider) {
                  _context5.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                gasLimitRatio = 1.05;
                _context5.next = 5;
                return this.provider.getNetwork();

              case 5:
                network = _context5.sent;
                chainId = network.chainId;
                registarAddr = this.chainMap[chainId].registarAddr;
                registarControllerContract = getRegistarControllerContract({
                  address: registarAddr,
                  provider: this.signer
                });

                if (!(!signature || signature == "")) {
                  _context5.next = 11;
                  break;
                }

                throw Error("No signature provided");

              case 11:
                if (!(!contents || contents == "")) {
                  _context5.next = 13;
                  break;
                }

                throw Error("No contents provided");

              case 13:
                _context5.next = 15;
                return registarControllerContract.estimateGas.registerWithToken(signature, contents, commissions, {
                  value: 0
                });

              case 15:
                estimateGas = _context5.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  value: 0,
                  gasLimit: gasLimit.toFixed(0)
                };
                _context5.next = 20;
                return registarControllerContract.registerWithToken(signature, contents, commissions, options);

              case 20:
                return _context5.abrupt("return", _context5.sent);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function registerWithToken(_x12, _x13, _x14, _x15) {
        return _registerWithToken.apply(this, arguments);
      }

      return registerWithToken;
    }()
    /**
     * renew
     * @param {signature} signature
     * @param {contents} contents
     * @param {feeDetails} usdToWei,[value1,value2..]
     * @param {pay value} value
     */

  }, {
    key: "renew",
    value: function () {
      var _renew = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(signature, contents, feeDetails, value) {
        var network, chainId, registarAddr, registarControllerContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.provider) {
                  _context6.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                _context6.next = 4;
                return this.provider.getNetwork();

              case 4:
                network = _context6.sent;
                chainId = network.chainId;
                registarAddr = this.chainMap[chainId].registarAddr;
                registarControllerContract = getRegistarControllerContract({
                  address: registarAddr,
                  provider: this.signer
                });

                if (!(!signature || signature == "")) {
                  _context6.next = 10;
                  break;
                }

                throw Error("No signature provided");

              case 10:
                if (!(!contents || contents == "")) {
                  _context6.next = 12;
                  break;
                }

                throw Error("No contents provided");

              case 12:
                if (!(!feeDetails || feeDetails == "")) {
                  _context6.next = 14;
                  break;
                }

                throw Error("No feeDetails provided");

              case 14:
                if (!(!value || value == "")) {
                  _context6.next = 16;
                  break;
                }

                throw Error("No value provided");

              case 16:
                gasLimitRatio = 1.05;
                _context6.next = 19;
                return registarControllerContract.estimateGas.extendExpireds(signature, contents, feeDetails, {
                  value: value
                });

              case 19:
                estimateGas = _context6.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  value: value,
                  gasLimit: gasLimit.toFixed(0)
                };
                _context6.next = 24;
                return registarControllerContract.extendExpireds(signature, contents, feeDetails, options);

              case 24:
                return _context6.abrupt("return", _context6.sent);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function renew(_x16, _x17, _x18, _x19) {
        return _renew.apply(this, arguments);
      }

      return renew;
    }()
    /**
    * renewWithToken
    * @param {signature} signature
    * @param {contents} contents
    * @param {feeDetails} usdToWei,[value1,value2..]
    * @param {pay value} value
    */

  }, {
    key: "renewWithToken",
    value: function () {
      var _renewWithToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(signature, contents, feeDetails, value) {
        var network, chainId, registarAddr, registarControllerContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.provider) {
                  _context7.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                _context7.next = 4;
                return this.provider.getNetwork();

              case 4:
                network = _context7.sent;
                chainId = network.chainId;
                registarAddr = this.chainMap[chainId].registarAddr;
                registarControllerContract = getRegistarControllerContract({
                  address: registarAddr,
                  provider: this.signer
                });

                if (!(!signature || signature == "")) {
                  _context7.next = 10;
                  break;
                }

                throw Error("No signature provided");

              case 10:
                if (!(!contents || contents == "")) {
                  _context7.next = 12;
                  break;
                }

                throw Error("No contents provided");

              case 12:
                if (!(!feeDetails || feeDetails == "")) {
                  _context7.next = 14;
                  break;
                }

                throw Error("No feeDetails provided");

              case 14:
                gasLimitRatio = 1.05;
                _context7.next = 17;
                return registarControllerContract.estimateGas.extendExpiredsWithToken(signature, contents, feeDetails, {
                  value: 0
                });

              case 17:
                estimateGas = _context7.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  value: 0,
                  gasLimit: gasLimit.toFixed(0)
                };
                _context7.next = 22;
                return registarControllerContract.extendExpiredsWithToken(signature, contents, feeDetails, options);

              case 22:
                return _context7.abrupt("return", _context7.sent);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function renewWithToken(_x20, _x21, _x22, _x23) {
        return _renewWithToken.apply(this, arguments);
      }

      return renewWithToken;
    }()
    /**
     * set reverseName of user's address
     * @param {domain name} name
     * @returns
     */

  }, {
    key: "setReverse",
    value: function () {
      var _setReverse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(name) {
        var network, chainId, defaultResolverAddr, resolverContract, tokenId, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (name) {
                  _context8.next = 2;
                  break;
                }

                throw Error("No name provided");

              case 2:
                if (this.provider) {
                  _context8.next = 4;
                  break;
                }

                throw Error("No provider provided");

              case 4:
                _context8.next = 6;
                return this.provider.getNetwork();

              case 6:
                network = _context8.sent;
                chainId = network.chainId;
                defaultResolverAddr = this.chainMap[chainId]['defaultResolverAddr'];
                resolverContract = getResolverContract({
                  address: defaultResolverAddr,
                  provider: this.signer
                });
                tokenId = nameHash(name);
                gasLimitRatio = 1.05;
                _context8.next = 14;
                return resolverContract.estimateGas.setReverse(tokenId);

              case 14:
                estimateGas = _context8.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context8.next = 19;
                return resolverContract.setReverse(tokenId, options);

              case 19:
                return _context8.abrupt("return", _context8.sent);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setReverse(_x24) {
        return _setReverse.apply(this, arguments);
      }

      return setReverse;
    }()
  }, {
    key: "removeReverse",
    value: function () {
      var _removeReverse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var network, chainId, defaultResolverAddr, resolverContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.provider) {
                  _context9.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                _context9.next = 4;
                return this.provider.getNetwork();

              case 4:
                network = _context9.sent;
                chainId = network.chainId;
                defaultResolverAddr = this.chainMap[chainId]['defaultResolverAddr'];
                resolverContract = getResolverContract({
                  address: defaultResolverAddr,
                  provider: this.signer
                });
                gasLimitRatio = 1.05;
                _context9.next = 11;
                return resolverContract.estimateGas.removeReverse();

              case 11:
                estimateGas = _context9.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio));
                console.log("gas: ", estimateGas.toString(), gasLimit.toFixed(0));
                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context9.next = 17;
                return resolverContract.removeReverse(options);

              case 17:
                return _context9.abrupt("return", _context9.sent);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function removeReverse() {
        return _removeReverse.apply(this, arguments);
      }

      return removeReverse;
    }()
    /**
     * get user's address via domain name
     * [Specified chain]
     * @param {user address} address
     * @returns domain name
     */

  }, {
    key: "getReverse",
    value: function () {
      var _getReverse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(address) {
        var network, chainId, defaultResolverAddr, resolverContract;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (this.provider) {
                  _context10.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                _context10.next = 4;
                return this.provider.getNetwork();

              case 4:
                network = _context10.sent;
                chainId = network.chainId;
                defaultResolverAddr = this.chainMap[chainId]['defaultResolverAddr'];
                resolverContract = getResolverContract({
                  address: defaultResolverAddr,
                  provider: this.provider
                });
                _context10.next = 10;
                return resolverContract.getReverse(address);

              case 10:
                return _context10.abrupt("return", _context10.sent);

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getReverse(_x25) {
        return _getReverse.apply(this, arguments);
      }

      return getReverse;
    }()
  }, {
    key: "scRetryPayload",
    value: function () {
      var _scRetryPayload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(srcLzChainId, srcDstContractAddr, nonce, payload) {
        var network, chainId, layerZeroManagerAddr, layerZeroManagerContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.provider.getNetwork();

              case 2:
                network = _context11.sent;
                chainId = network.chainId;
                layerZeroManagerAddr = this.chainMap[chainId].layerZeroManagerAddr;
                layerZeroManagerContract = getLayerZeroManagerContract({
                  address: layerZeroManagerAddr,
                  provider: this.signer
                });
                gasLimitRatio = 1.05;
                _context11.next = 9;
                return layerZeroManagerContract.estimateGas.scRetryPayload(srcLzChainId, srcDstContractAddr, nonce, payload);

              case 9:
                estimateGas = _context11.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio));
                console.log("gas: ", estimateGas.toString(), gasLimit.toFixed(0));
                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context11.next = 15;
                return layerZeroManagerContract.scRetryPayload(srcLzChainId, srcDstContractAddr, nonce, payload, options);

              case 15:
                return _context11.abrupt("return", _context11.sent);

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function scRetryPayload(_x26, _x27, _x28, _x29) {
        return _scRetryPayload.apply(this, arguments);
      }

      return scRetryPayload;
    }()
  }]);
  return ON;
}();

exports["default"] = ON;

var Name = /*#__PURE__*/function () {
  function Name(options) {
    (0, _classCallCheck2["default"])(this, Name);
    var root = options.root,
        name = options.name,
        provider = options.provider,
        signer = options.signer,
        supportChainIds = options.supportChainIds,
        chainMap = options.chainMap;
    this.root = root;
    this.provider = provider;
    this.signer = signer;
    this.name = name;
    this.supportChainIds = supportChainIds;
    this.chainMap = chainMap;
  }
  /**
   * get record of current name
   * [By cross-chain query]
   * @param chainId  if null,query by cross chain. if not null, Query in the specified chain
   * @returns [parseAddr,expireTime,name,chainId,expireTime of grace,expire time of auction]
   */


  (0, _createClass2["default"])(Name, [{
    key: "getRecord",
    value: function () {
      var _getRecord = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(chainId) {
        var record, promises, index, _chainId, registryEndPointAddr, provider, registryEndPointContract, allRes, maxIndex, maxExpiredTime, _index, result, _chainId2, _record, _registryEndPointAddr, _provider, _registryEndPointContract, tmp, k, ts;

        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!chainId || chainId < 0)) {
                  _context12.next = 30;
                  break;
                }

                promises = [];

                for (index = 0; index < this.supportChainIds.length; index++) {
                  _chainId = this.supportChainIds[index];
                  registryEndPointAddr = this.chainMap[_chainId].registryEndPointAddr;
                  provider = this.chainMap[_chainId].rpcProvider;
                  registryEndPointContract = getRegistryEndPointContract({
                    address: registryEndPointAddr,
                    provider: provider
                  });
                  promises.push(registryEndPointContract.getRecord(this.name));
                }

                _context12.next = 5;
                return Promise.allSettled(promises);

              case 5:
                allRes = _context12.sent;
                maxIndex = -1;
                maxExpiredTime = 0;
                _index = 0;

              case 9:
                if (!(_index < allRes.length)) {
                  _context12.next = 24;
                  break;
                }

                result = allRes[_index];

                if (!(result.status === "rejected")) {
                  _context12.next = 15;
                  break;
                }

                _chainId2 = this.supportChainIds[_index];
                console.error("chainId: " + _chainId2 + " " + result.reason);
                throw Error("chainId: " + _chainId2 + " " + result.reason);

              case 15:
                _record = result.value;

                if (!(_record && _record[2] && _record[2].length > 0)) {
                  _context12.next = 21;
                  break;
                }

                if (!(_record[1] == 0)) {
                  _context12.next = 20;
                  break;
                }

                maxIndex = _index;
                return _context12.abrupt("break", 24);

              case 20:
                if (_record[1] > maxExpiredTime) {
                  maxExpiredTime = _record[1];
                  maxIndex = _index;
                }

              case 21:
                _index++;
                _context12.next = 9;
                break;

              case 24:
                if (!(maxIndex == -1 || maxIndex >= allRes.length)) {
                  _context12.next = 26;
                  break;
                }

                return _context12.abrupt("return", undefined);

              case 26:
                record = allRes[maxIndex].value;
                chainId = this.supportChainIds[maxIndex];
                _context12.next = 40;
                break;

              case 30:
                if (this.chainMap[chainId]) {
                  _context12.next = 32;
                  break;
                }

                throw Error("chainId is not support: ", chainId);

              case 32:
                // Query in the specified chain
                _registryEndPointAddr = this.chainMap[chainId].registryEndPointAddr;

                if (_registryEndPointAddr) {
                  _context12.next = 35;
                  break;
                }

                throw Error("chainId is not supported: " + chainId);

              case 35:
                _provider = this.chainMap[chainId].rpcProvider;
                _registryEndPointContract = getRegistryEndPointContract({
                  address: _registryEndPointAddr,
                  provider: _provider
                });
                _context12.next = 39;
                return _registryEndPointContract.getRecord(this.name);

              case 39:
                record = _context12.sent;

              case 40:
                if (!record) {
                  _context12.next = 50;
                  break;
                }

                if (!(record[2] == '')) {
                  _context12.next = 43;
                  break;
                }

                return _context12.abrupt("return", undefined);

              case 43:
                tmp = new Array();

                for (k = 0; k < record.length; k++) {
                  tmp[k] = record[k];
                }

                ts = tmp[1].toNumber();
                tmp[1] = ts;
                tmp[3] = chainId;

                if (ts == 0) {
                  tmp[4] = 0;
                  tmp[5] = 0;
                } else {
                  // expire time of grace period
                  tmp[4] = ts + sdkConfig.GRACE_PERIOD_SECONDS; // expire time of auction period

                  tmp[5] = ts + sdkConfig.GRACE_PERIOD_SECONDS + sdkConfig.AUCTION_PERIOD_SECONDS;
                }

                return _context12.abrupt("return", tmp);

              case 50:
                return _context12.abrupt("return", undefined);

              case 51:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getRecord(_x30) {
        return _getRecord.apply(this, arguments);
      }

      return getRecord;
    }()
    /**
     * check whether the domain is registered
     * @param chainId  if null or -1, query cross chains,if not null,query on one chain
     * @param nowTs current utc time,please use the server time
     * @returns
     * 0-unregistered
     * 1-registered and within its validity
     * 2-registered and in grace period
     * 3-registered and in auction period
     */

  }, {
    key: "isRegistered",
    value: function () {
      var _isRegistered = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(chainId, nowTs) {
        var record, recordExpiredTime;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                record = null;

                if (!(!chainId || chainId == -1)) {
                  _context13.next = 7;
                  break;
                }

                _context13.next = 4;
                return this.getRecord();

              case 4:
                record = _context13.sent;
                _context13.next = 10;
                break;

              case 7:
                _context13.next = 9;
                return this.getRecord(chainId);

              case 9:
                record = _context13.sent;

              case 10:
                if (!(!record || !record[2] || record[2] == "")) {
                  _context13.next = 12;
                  break;
                }

                return _context13.abrupt("return", 0);

              case 12:
                recordExpiredTime = record[1];

                if (!(nowTs <= recordExpiredTime || recordExpiredTime == 0)) {
                  _context13.next = 15;
                  break;
                }

                return _context13.abrupt("return", 1);

              case 15:
                if (!(nowTs <= record[4])) {
                  _context13.next = 17;
                  break;
                }

                return _context13.abrupt("return", 2);

              case 17:
                if (!(nowTs <= record[5])) {
                  _context13.next = 19;
                  break;
                }

                return _context13.abrupt("return", 3);

              case 19:
                return _context13.abrupt("return", 0);

              case 20:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function isRegistered(_x31, _x32) {
        return _isRegistered.apply(this, arguments);
      }

      return isRegistered;
    }()
    /**
     * set name's address of coinType
     * @param {coin type} coinType
     * @param {coin address} address
     * @returns
     */

  }, {
    key: "setAddr",
    value: function () {
      var _setAddr = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(coinType, address) {
        var network, chainId, record, resolverAddr;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (coinType) {
                  _context14.next = 2;
                  break;
                }

                throw new Error('No coinType provided');

              case 2:
                if (address) {
                  _context14.next = 4;
                  break;
                }

                throw new Error('No address provided');

              case 4:
                _context14.next = 6;
                return this.provider.getNetwork();

              case 6:
                network = _context14.sent;
                chainId = network.chainId;
                _context14.next = 10;
                return this.getRecord(chainId);

              case 10:
                record = _context14.sent;

                if (!(!record || record[2] == '')) {
                  _context14.next = 13;
                  break;
                }

                throw new Error('Domain name does not exist');

              case 13:
                resolverAddr = record[0];
                return _context14.abrupt("return", setAddrWithResolver({
                  name: this.name,
                  coinType: coinType,
                  address: address,
                  resolverAddr: resolverAddr,
                  signer: this.signer
                }));

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setAddr(_x33, _x34) {
        return _setAddr.apply(this, arguments);
      }

      return setAddr;
    }()
    /**
     * get name's address of coinType
     * @param {coin type} coinType
     * @returns
     */

  }, {
    key: "getAddr",
    value: function () {
      var _getAddr = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(coinType) {
        var network, chainId, record, contract, tokenId, addrBytes, addrStr, addr;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(coinType != 0 && !coinType)) {
                  _context15.next = 2;
                  break;
                }

                throw new Error('No coinType provided');

              case 2:
                _context15.next = 4;
                return this.provider.getNetwork();

              case 4:
                network = _context15.sent;
                chainId = network.chainId;
                _context15.next = 8;
                return this.getRecord(chainId);

              case 8:
                record = _context15.sent;

                if (!(!record || record[2] == '')) {
                  _context15.next = 11;
                  break;
                }

                return _context15.abrupt("return", _records.emptyAddress);

              case 11:
                _context15.next = 13;
                return this.getResolver(record);

              case 13:
                contract = _context15.sent;
                tokenId = nameHash(this.name);
                _context15.next = 17;
                return contract.functions["getAddr(uint256,uint256)"](tokenId, coinType);

              case 17:
                addrBytes = _context15.sent;
                addrStr = String(addrBytes).slice(2);

                if (!(!addrStr || addrStr == "")) {
                  _context15.next = 21;
                  break;
                }

                return _context15.abrupt("return", "");

              case 21:
                addr = String(Buffer.from(addrStr, "hex"));

                if (!sdkConfig.ETH_COIN_TYPE_LIST.includes(coinType)) {
                  _context15.next = 26;
                  break;
                }

                return _context15.abrupt("return", _ethers.ethers.utils.getAddress(addr));

              case 26:
                return _context15.abrupt("return", addr);

              case 27:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getAddr(_x35) {
        return _getAddr.apply(this, arguments);
      }

      return getAddr;
    }()
    /** 
     * @param {srcChainId} srcChainId
     * @param {target lz chain id} dstLzChainId
     * @param {scale the pay value} scale, default 1.
     * @returns value : string
     */

  }, {
    key: "estimateMigrateToken",
    value: function () {
      var _estimateMigrateToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(srcChainId, dstLzChainId, scale) {
        var tokenId, promisAny, rpcProviders, i, rpcProvider, registryEndPointAddr, registryEndPointContract, promisOne, payValue, finalPayValue;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                tokenId = (0, _util.getTokenId)(this.name);

                if (!(tokenId == 0x00)) {
                  _context16.next = 3;
                  break;
                }

                throw Error("Domain name does not exist");

              case 3:
                if (srcChainId) {
                  _context16.next = 5;
                  break;
                }

                throw Error("No srcChainId provided");

              case 5:
                if (!scale) {
                  scale = "1.0";
                }

                promisAny = [];
                rpcProviders = this.chainMap[srcChainId].rpcProviders;

                for (i = 0; i < rpcProviders.length; i++) {
                  rpcProvider = rpcProviders[i];
                  registryEndPointAddr = this.chainMap[srcChainId].registryEndPointAddr;
                  registryEndPointContract = getRegistryEndPointContract({
                    address: registryEndPointAddr,
                    provider: rpcProvider
                  });
                  promisOne = registryEndPointContract.getMigrateTokenEstimate(dstLzChainId, tokenId);
                  promisAny.push(promisOne);
                } // Promise.any 


                _context16.next = 11;
                return Promise.any(promisAny);

              case 11:
                payValue = _context16.sent;
                finalPayValue = new _bignumber["default"](payValue.toString()).multipliedBy(new _bignumber["default"]("" + scale));
                return _context16.abrupt("return", finalPayValue.toFixed(0));

              case 14:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function estimateMigrateToken(_x36, _x37, _x38) {
        return _estimateMigrateToken.apply(this, arguments);
      }

      return estimateMigrateToken;
    }()
    /**
     * migrate tokenId to another chain which chainId is dstChainId
     * @param {dstLzChainId} dstLzChainId 
     * @param {signature} signature
     * @param {contents} contents
     * @param {fee} fee
     * @param {usdToWei} usdToWei
     * @param {payValue} payValue
     */

  }, {
    key: "migrateToken",
    value: function () {
      var _migrateToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(dstLzChainId, signature, contents, fee, usdToWei, payValue) {
        var network, chainId, tokenId, registryEndPointAddr, registryEndPointContract, options, gasLimitRatio, estimateGas, gasLimit;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.provider) {
                  _context17.next = 2;
                  break;
                }

                throw Error("No provider provided");

              case 2:
                if (!(!signature || signature == "")) {
                  _context17.next = 4;
                  break;
                }

                throw Error("No signature provided");

              case 4:
                if (!(!contents || contents == "")) {
                  _context17.next = 6;
                  break;
                }

                throw Error("No contents provided");

              case 6:
                if (!(!fee || fee == "")) {
                  _context17.next = 8;
                  break;
                }

                throw Error("No fee provided");

              case 8:
                if (!(!usdToWei || usdToWei == "")) {
                  _context17.next = 10;
                  break;
                }

                throw Error("No usdToWei provided");

              case 10:
                if (!(!payValue || payValue == "")) {
                  _context17.next = 12;
                  break;
                }

                throw Error("No payValue provided");

              case 12:
                _context17.next = 14;
                return this.provider.getNetwork();

              case 14:
                network = _context17.sent;
                chainId = network.chainId;
                tokenId = (0, _util.getTokenId)(this.name);
                console.log(this.name, tokenId);

                if (!(tokenId == 0x00)) {
                  _context17.next = 20;
                  break;
                }

                throw Error("Domain name does not exist");

              case 20:
                registryEndPointAddr = this.chainMap[chainId].registryEndPointAddr;
                registryEndPointContract = getRegistryEndPointContract({
                  address: registryEndPointAddr,
                  provider: this.signer
                });
                options = {
                  value: payValue
                };
                gasLimitRatio = 1.05;
                _context17.next = 26;
                return registryEndPointContract.estimateGas.migrateOutToken(signature, contents, fee, usdToWei, options);

              case 26:
                estimateGas = _context17.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio));
                options.gasLimit = gasLimit.toFixed(0);
                _context17.next = 31;
                return registryEndPointContract.migrateOutToken(signature, contents, fee, usdToWei, options);

              case 31:
                return _context17.abrupt("return", _context17.sent);

              case 32:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function migrateToken(_x39, _x40, _x41, _x42, _x43, _x44) {
        return _migrateToken.apply(this, arguments);
      }

      return migrateToken;
    }() // get name resolver

  }, {
    key: "getResolver",
    value: function () {
      var _getResolver = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(record) {
        var chainId, chainInfo, resolveAddress, provider, contract;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                chainId = record[3];
                chainInfo = this.chainMap[chainId]; // get resolver address from domainInfo

                resolveAddress = record[0];
                provider = chainInfo.rpcProvider;

                if (!(resolveAddress != _records.emptyAddress)) {
                  _context18.next = 7;
                  break;
                }

                contract = getResolverContract({
                  address: resolveAddress,
                  provider: provider
                });
                return _context18.abrupt("return", contract);

              case 7:
                throw Error("resolveAddress is null for chainId: " + chainId);

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getResolver(_x45) {
        return _getResolver.apply(this, arguments);
      }

      return getResolver;
    }()
  }, {
    key: "multicallWithTokenId",
    value: function () {
      var _multicallWithTokenId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
        var addressList,
            textList,
            otherList,
            network,
            chainId,
            tokenId,
            record,
            resolverAddr,
            resolverCoreContract,
            data,
            gasLimitRatio,
            estimateGas,
            gasLimit,
            options,
            _args19 = arguments;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                addressList = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : [];
                textList = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : [];
                otherList = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : [];
                _context19.next = 5;
                return this.provider.getNetwork();

              case 5:
                network = _context19.sent;
                chainId = network.chainId;
                tokenId = (0, _util.getTokenId)(this.name);

                if (!(tokenId == 0x00)) {
                  _context19.next = 10;
                  break;
                }

                throw Error("Domain does not exist");

              case 10:
                _context19.next = 12;
                return this.getRecord(chainId);

              case 12:
                record = _context19.sent;

                if (!(!record || record[2] == '')) {
                  _context19.next = 15;
                  break;
                }

                throw new Error('Domain does not exist');

              case 15:
                resolverAddr = record[0];
                resolverCoreContract = getResolverContract({
                  address: resolverAddr,
                  provider: this.signer
                });
                data = [];
                addressList.forEach(function (item, index) {
                  var dataItem = resolverCoreContract["interface"].encodeFunctionData("setAddr(uint256,uint256,bytes)", [tokenId, item.coinType, _ethers.ethers.utils.toUtf8Bytes(item.walletAddress)]);
                  data.push(dataItem);
                });
                textList.forEach(function (item, index) {
                  var dataItem = resolverCoreContract["interface"].encodeFunctionData("setTextValue(uint256,string,string)", [tokenId, item.key, item.value]);
                  data.push(dataItem);
                });
                otherList.forEach(function (item) {
                  var dataItem = resolverCoreContract["interface"].encodeFunctionData("setBytesValue", [tokenId, _ethers.ethers.utils.toUtf8Bytes(item.key), _ethers.ethers.utils.toUtf8Bytes(item.value)]);
                  data.push(dataItem);
                });
                gasLimitRatio = 1.05;
                _context19.next = 24;
                return resolverCoreContract.estimateGas.multicallWithTokenId(tokenId, data);

              case 24:
                estimateGas = _context19.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context19.next = 29;
                return resolverCoreContract.multicallWithTokenId(tokenId, data, options);

              case 29:
                return _context19.abrupt("return", _context19.sent);

              case 30:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function multicallWithTokenId() {
        return _multicallWithTokenId.apply(this, arguments);
      }

      return multicallWithTokenId;
    }()
    /**
     * param
     * to:Address set
     *
     */

  }, {
    key: "approve",
    value: function () {
      var _approve = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(to) {
        var network, chainId, tokenId, registryCoreAddr, registryCoreContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.provider.getNetwork();

              case 2:
                network = _context20.sent;
                chainId = network.chainId;
                tokenId = (0, _util.getTokenId)(this.name);

                if (!(tokenId == 0x00)) {
                  _context20.next = 7;
                  break;
                }

                throw Error("Domain name does not exist");

              case 7:
                registryCoreAddr = this.chainMap[chainId].registryCoreAddr;
                registryCoreContract = getRegistryCoreContract({
                  address: registryCoreAddr,
                  provider: this.signer
                });
                gasLimitRatio = 1.05;
                _context20.next = 12;
                return registryCoreContract.estimateGas.approve(to, tokenId);

              case 12:
                estimateGas = _context20.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context20.next = 17;
                return registryCoreContract.approve(to, tokenId, options);

              case 17:
                return _context20.abrupt("return", _context20.sent);

              case 18:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function approve(_x46) {
        return _approve.apply(this, arguments);
      }

      return approve;
    }()
  }, {
    key: "burnToken",
    value: function () {
      var _burnToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
        var network, chainId, tokenId, managerAddr, managerContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.provider.getNetwork();

              case 2:
                network = _context21.sent;
                chainId = network.chainId;
                tokenId = (0, _util.getTokenId)(this.name);

                if (!(tokenId == 0x00)) {
                  _context21.next = 7;
                  break;
                }

                throw Error("Domain name does not exist");

              case 7:
                managerAddr = this.chainMap[chainId].managerAddr;
                managerContract = getRegistryManagerContract({
                  address: managerAddr,
                  provider: this.signer
                });
                gasLimitRatio = 1.05;
                _context21.next = 12;
                return managerContract.estimateGas.burnToken(tokenId);

              case 12:
                estimateGas = _context21.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio)); // console.log("gas: ",estimateGas.toString(), gasLimit.toFixed(0))

                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context21.next = 17;
                return managerContract.burnToken(tokenId, options);

              case 17:
                return _context21.abrupt("return", _context21.sent);

              case 18:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function burnToken() {
        return _burnToken.apply(this, arguments);
      }

      return burnToken;
    }()
    /**
     * param
     * to:Address set
     *
     */

  }, {
    key: "transferFrom",
    value: function () {
      var _transferFrom = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(from, to) {
        var network, chainId, tokenId, registryCoreAddr, registryCoreContract, gasLimitRatio, estimateGas, gasLimit, options;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.provider.getNetwork();

              case 2:
                network = _context22.sent;
                chainId = network.chainId;
                tokenId = (0, _util.getTokenId)(this.name);

                if (!(tokenId == 0x00)) {
                  _context22.next = 7;
                  break;
                }

                throw Error("Domain name does not exist");

              case 7:
                registryCoreAddr = this.chainMap[chainId].registryCoreAddr;
                registryCoreContract = getRegistryCoreContract({
                  address: registryCoreAddr,
                  provider: this.signer
                });
                gasLimitRatio = 1.05;
                _context22.next = 12;
                return registryCoreContract.estimateGas.transferFrom(from, to, tokenId);

              case 12:
                estimateGas = _context22.sent;
                gasLimit = new _bignumber["default"](estimateGas.toString()).multipliedBy(new _bignumber["default"]("" + gasLimitRatio));
                console.log("gas: ", estimateGas.toString(), gasLimit.toFixed(0));
                options = {
                  gasLimit: gasLimit.toFixed(0)
                };
                _context22.next = 18;
                return registryCoreContract.transferFrom(from, to, tokenId, options);

              case 18:
                return _context22.abrupt("return", _context22.sent);

              case 19:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function transferFrom(_x47, _x48) {
        return _transferFrom.apply(this, arguments);
      }

      return transferFrom;
    }()
  }, {
    key: "getExponentialPremiumPriceUsd",
    value: function () {
      var _getExponentialPremiumPriceUsd = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(chainId, currentTs) {
        var record, graceTs, dutchAuctionTime, priceOracle, daysPast, currentPrice;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (chainId) {
                  _context23.next = 2;
                  break;
                }

                throw new Error("No chainId provided");

              case 2:
                if (currentTs) {
                  _context23.next = 4;
                  break;
                }

                throw new Error("No currentTs provided");

              case 4:
                _context23.next = 6;
                return this.getRecord(chainId);

              case 6:
                record = _context23.sent;

                if (record) {
                  _context23.next = 9;
                  break;
                }

                throw new Error("name does not exists!");

              case 9:
                graceTs = record[4];

                if (!(currentTs < graceTs)) {
                  _context23.next = 12;
                  break;
                }

                return _context23.abrupt("return", 0);

              case 12:
                dutchAuctionTime = (0, _moment["default"])(graceTs * 1000); // console.log(dutchAuctionTime)

                priceOracle = new _PremiumPriceOracle["default"](dutchAuctionTime, "exponential");
                daysPast = priceOracle.getDaysPast((0, _moment["default"])(currentTs * 1000));
                currentPrice = priceOracle.getTargetAmountByDaysPast(daysPast);
                return _context23.abrupt("return", currentPrice);

              case 17:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getExponentialPremiumPriceUsd(_x49, _x50) {
        return _getExponentialPremiumPriceUsd.apply(this, arguments);
      }

      return getExponentialPremiumPriceUsd;
    }()
  }]);
  return Name;
}();

var Currency = /*#__PURE__*/function () {
  function Currency(options) {
    (0, _classCallCheck2["default"])(this, Currency);
    var contract = options.contract,
        chainId = options.chainId,
        provider = options.provider,
        signer = options.signer,
        precisionNum = options.precisionNum,
        chainMap = options.chainMap;
    this.chainId = chainId;
    this.provider = provider;
    this.signer = signer;
    this.precisionNum = precisionNum;
    this.chainMap = chainMap;
    this.contract = contract;
    this.registarAddr = this.chainMap[this.chainId].registarAddr;
  }

  (0, _createClass2["default"])(Currency, [{
    key: "currencyLicense",
    value: function currencyLicense() {
      return getCurrencyLicense({
        address: this.contract,
        provider: this.signer
      });
    }
  }, {
    key: "balanceOf",
    value: function () {
      var _balanceOf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(address) {
        var res;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.currencyLicense().balanceOf(address);

              case 2:
                res = _context24.sent;
                return _context24.abrupt("return", this.getValue(res._hex));

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function balanceOf(_x51) {
        return _balanceOf.apply(this, arguments);
      }

      return balanceOf;
    }()
  }, {
    key: "approval",
    value: function () {
      var _approval = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(value) {
        var res;
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                value = this.transform("".concat(value));
                console.log(value);
                _context25.next = 4;
                return this.currencyLicense().approve(this.registarAddr, value);

              case 4:
                res = _context25.sent;
                return _context25.abrupt("return", res);

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function approval(_x52) {
        return _approval.apply(this, arguments);
      }

      return approval;
    }()
  }, {
    key: "transfer",
    value: function () {
      var _transfer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(value) {
        var res;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                value = this.transform("".concat(value));
                _context26.next = 3;
                return this.currencyLicense().transfer(this.registarAddr, value);

              case 3:
                res = _context26.sent;
                return _context26.abrupt("return", res);

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function transfer(_x53) {
        return _transfer.apply(this, arguments);
      }

      return transfer;
    }()
  }, {
    key: "allowance",
    value: function () {
      var _allowance = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(owner) {
        var res;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.currencyLicense().allowance(owner, this.registarAddr);

              case 2:
                res = _context27.sent;
                return _context27.abrupt("return", this.getValue(res._hex));

              case 4:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function allowance(_x54) {
        return _allowance.apply(this, arguments);
      }

      return allowance;
    }()
  }, {
    key: "getValue",
    value: function getValue(balance) {
      balance = new _bignumber["default"](balance);
      var divValue = this.precision();
      return new _bignumber["default"](balance.div(divValue)).toString();
    }
  }, {
    key: "precision",
    value: function precision() {
      return new _bignumber["default"](10).pow(this.precisionNum);
    }
  }, {
    key: "transform",
    value: function transform(value) {
      if (this.precisionNum == 18 && Number(value) >= 1000) {
        var web3 = new _web["default"]();
        value = web3.utils.toWei(value, 'ether');
        console.log(value);
      } else {
        value = new _bignumber["default"](value);
        var big18 = this.precision();
        value = new _bignumber["default"](value.times(big18)).toString();
      }

      return value;
    }
  }]);
  return Currency;
}();

function nameHash(name) {
  return _ethers.ethers.utils.keccak256(_ethers.ethers.utils.toUtf8Bytes(name));
}

function getRegistarControllerContract(_ref2) {
  var address = _ref2.address,
      provider = _ref2.provider;
  return new _ethers.ethers.Contract(address, _ONRegistrarController.abi, provider);
}

function getRegistryManagerContract(_ref3) {
  var address = _ref3.address,
      provider = _ref3.provider;
  return new _ethers.ethers.Contract(address, _ONRegistryManager.abi, provider);
}

function getRegistryEndPointContract(_ref4) {
  var address = _ref4.address,
      provider = _ref4.provider;
  return new _ethers.ethers.Contract(address, _ONRegistryEndPoint.abi, provider);
}

function getResolverContract(_ref5) {
  var address = _ref5.address,
      provider = _ref5.provider;
  return new _ethers.ethers.Contract(address, _DefaultResolver.abi, provider);
}

function getRegistryCoreContract(_ref6) {
  var address = _ref6.address,
      provider = _ref6.provider;
  return new _ethers.ethers.Contract(address, _ONRegistryCore.abi, provider);
}

function getLayerZeroManagerContract(_ref7) {
  var address = _ref7.address,
      provider = _ref7.provider;
  return new _ethers.ethers.Contract(address, _LayerZeroManager.abi, provider);
}

function getCurrencyLicense(_ref8) {
  var address = _ref8.address,
      provider = _ref8.provider;
  return new _ethers.ethers.Contract(address, _Erc20BalanceOf.abi, provider);
}